var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DraftQuestionAd_1;
import React from 'react';
import { observer } from 'mobx-react';
import { Aspect_ } from '../../../../components/actor/Aspect_';
import { runtime } from '../../../../classes/runtime/Runtime';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
let DraftQuestionAd = DraftQuestionAd_1 = class DraftQuestionAd extends React.PureComponent {
    render() {
        const { question } = this.props;
        /*
    Verbesserungen an responsiven Anzeigenblöcken
        https://support.google.com/adsense/answer/9467650?hl=de
    <ins class="adsbygoogle"
       style="display:inline-block;min-width:400px;max-width:970px;width:100%;height:90px"
         */
        if (!runtime.availablePackages.Defer)
            return null;
        const { GoogleAd } = runtime.availablePackages.Defer.components;
        if (!question.context.app.user)
            return null;
        if (question.context.app.appInfo.isMobileAppWebView)
            return null;
        if (question.context.app.user.userInfo.isPremiumUser)
            return null;
        const { width, height } = question.ownAspect.ad.aspectCss.css;
        if (width > 0 && width < 100)
            return null;
        if (height > 0 && height < 100)
            return null;
        const adStyle = {
            height: '100%',
            width: '100%',
            minWidth: 100,
            minHeight: 100,
            maxWidth: width,
            maxHeight: height,
        };
        return (React.createElement(Aspect_, { aspect: question.ownAspect.ad, templateComponent: DraftQuestionAd_1.templateComponent },
            React.createElement(GoogleAd, { app: question.context.app, slotId: 6455524215, style: adStyle })));
    }
    static get templateComponent() {
        return (React.createElement("div", { style: {
                position: 'absolute',
                top: 0,
                left: 0,
                width: 300,
                height: 250,
            } }));
    }
};
__decorate([
    memoize
], DraftQuestionAd, "templateComponent", null);
DraftQuestionAd = DraftQuestionAd_1 = __decorate([
    observer
], DraftQuestionAd);
export { DraftQuestionAd };
/*

 <div style={{ width: 50, height: 50, position: 'absolute', opacity: 0.5 }}>
          <Popover placement="topRight" content={this.popoverContent} trigger="hover">
            <img
              src="/static/img/funwithdad.png"
              title="Auf Schlaukopf Premium wechseln"
              style={{
                width: 50,
                height: 50,
                position: 'relative',
                top: -60,
                cursor: 'pointer',
                left: question.ownAspect.ad.aspectCss.css.width / 2 - 25
              }}
              onClick={action(
                () => (this.props.question.context.app.menubar.menubarRight.isPremiumDialogShowing = true)
              )}
            />
          </Popover>
          <span
            style={{
              color: 'rgba(194,142,86,0.8)',
              position: 'relative',
              top: -80,
              cursor: 'pointer',
              left: question.ownAspect.ad.aspectCss.css.width / 2 + 25
            }}
          >
            Anzeige
          </span>
        </div>

 */
